import React from "react";
import Image from "gatsby-image";
import { ArtprogresImage } from "./ArtprogresImage";

export const ArtprogresData = () => {
  const images = ArtprogresImage();
  return {
    color: "#ABC539",
    title: "Artprogres",
    seo:
      "Zaprojektowaliśmy i wdrożyliśmy stronę internetową, która przedstawia jej ofertę i stanowi wizytówkę w sieci.",
    slug: "artprogres",
    hero: {
      title: "Nowoczesny branding i strategia marki.",
      color: "#ABC539",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Nowoczesne technologie w programowaniu",

      technologies: ["Strona WWW", "UX Workshops", "Gatsby", "React.js"],
      text:
        "ArtProgres to marka, która - podobnie jak my - od lat zapewnia kompleksowe rozwiązania dla wielu branż. Zaprojektowaliśmy i wdrożyliśmy stronę internetową, która przedstawia jej ofertę i stanowi wizytówkę w sieci. Stworzyliśmy estetyczną i wydajną witrynę, wykorzystując rozwiązania, które poprawiają jej dynamikę i wygląd. Dzięki temu strona WWW spełnia swoje zadania i odpowiada na potrzeby i oczekiwania użytkowników. ",
      list: [
        "Stworzyliśmy nową stronę wizytówkową",
        "Wykorzystaliśmy framework Gatsby i React.js",
        "Zaprojektowaliśmy wygląd w oparciu o istniejący branding marki",
      ],
    },
    headers: {
      first: "Optymalizacja to podstawa",
      second: "Responsive Web Desing ",
    },
    text_boxes: {
      first: {
        title: "Struktura przyjazna SEO",
        text:
          "Pozycjonowanie to wciąż jeden z najlepszych sposobów na dobrą widoczność w internecie. Warto przemyśleć odpowiednią strukturę strony i jej nawigację. Zaprojektowana przez nas witryna jest SEO friendly, co w przyszłości ułatwi pracę osobie odpowiedzialnej za pozycjonowanie.",
      },
      second: {
        title: "Pomysł na design",
        text:
          "Projekt strony ArtProgres powstał na podstawie istniejącej już identyfikacji wizualnej marki, która jest rozpoznawalna wśród osób z branży i klientów firmy. Minimalizm i przejrzystość to główne cechy nowoczesnych stron internetowych, o które oparliśmy naszą kreacje.",
      },
      third: {
        title: "Strony dostosowane do każdego urządzenia",
        text:
          "Projektujemy strony, które odpowiednio dopasowują się do każdego ekranu. Coraz więcej użytkowników internetu korzysta wyłącznie z urządzeń mobilnych, dlatego tak ważne jest, aby dostosować wygląd strony do smartfonów i tabletów. Stosujemy technologie, dzięki którym witryny są w pełni responsywne.",
      },
      fourth: {
        title: "Wartość dla klientów",
        text:
          "Strona jest wizytówką firmy, na której znajdują się zakładki takie jak oferta, realizacje czy możliwości kontaktu. Podstrony informacyjne zaprojektowaliśmy czytelnie i bez zbędnych elementów, które mogą odwrócić uwagę od tego, co najważniejsze - przedstawienia firmy i jej oferty.",
      },
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.art_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.art_2.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        title: "",
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_3f.childImageSharp.fluid}
          />
        ),
      },
    },
    sticky: {
      first: {
        main: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_1s.childImageSharp.fluid}
          />
        ),
        phone: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_1p.childImageSharp.fluid}
          />
        ),
        title: "Przyśpieszone ładowanie strony",
        text:
          "W naszej pracy wykorzystujemy nowoczesny framework Gatsby.js, który pozwala na budowanie zoptymalizowanych stron i aplikacji internetowych. Stworzenie strony WWW przy użyciu tego narzędzia umożliwia jej szybsze ładowanie. Wpływa także pozytywnie na pozycjęi jej indeksowanie w wyszukiwarce.",
      },
      second: {
        main: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_2s.childImageSharp.fluid}
          />
        ),
        phone: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.art_2p.childImageSharp.fluid}
          />
        ),
        title: "Stawiamy na React.js",
        text:
          "Biblioteka React.js to obecnie najszybsza implementacja tego rodzaju, co pozwala na zakodowanie strony internetowej w krótszym czasie. Wysoce wydajny i dynamiczny interfejs, szybkie aktualizacje, zmiany w czasie rzeczywistym - wszystko to wpływa na wydajność strony ArtProgres.",
      },
    },
  };
};
